<template>
    <el-container style="height: 100%;overflow: hidden">
        <el-header style="padding: 0;width: 100%">
            <v-head></v-head>
        </el-header>
        <el-container>
            <el-aside class="home_aside" width="160px">
                <v-sidebar></v-sidebar>
            </el-aside>
            <el-main :class="{'content-collapse':collapse}" style="padding: 0">
                <div class="view_content">
                    <v-tags></v-tags>
                    <div style="flex-grow: 1;overflow-y: auto;">
                        <transition name="move" mode="out-in">
                            <keep-alive :include="tagsList">
                                <router-view :key="$route.fullPath"></router-view>
                            </keep-alive>
                        </transition>
                    </div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import vHead from './Header.vue';
    import vSidebar from './Sidebar.vue';
    import vTags from './Tags.vue';
    import bus from './Eventbus';
    export default {
        data(){
            return {
                tagsList: [],
                collapse: false
            }
        },
        components:{
            vHead, vSidebar, vTags
        },
        created(){
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })

            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                let arr = [];
                for(let i = 0, len = msg.length; i < len; i ++){
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            })
            // this.checkLogin()
        },  
        methods: {
            checkLogin(){
            let userLogin = localStorage.getItem("ms_username");
                if(userLogin == undefined) {
                    this.$router.push('/login');
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
//    @import "../../../../public/css/common";

    .home_aside{
        overflow-x: hidden;
        background-color: #ffffff;
       border-right: 1px solid #DAE3F2 !important;
    }
    .view_content{
        width: 100%;
        height: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
    }
</style>
